<template>
  <div class="row">
    <div class="col-xl-4 col-md-6 mb-3"
         v-for="item in list"
         :key="item.id">
      <div class="portfolioCard"
           :style="{
                backgroundImage: item.media.length
                    ? `url(/storage/${item.media[0].id}/${item.media[0].file_name})`
                    : ''
            }">
        <div class="portfolioCard__body"><span class="portfolioCard__body-title">{{$lang(item.title)}}</span>
            <div v-html="$lang(item.description)"></div>
          <a class="btn btn-outline-light portfolioCard__btn"
             :href="`${lang_prefix}/albums/${item.category.slug}/${item.slug}`">details</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AlbumItem',
  computed: {
    ...mapGetters('album', ['list']),
    lang_prefix () {
      return this.$currentLang === 'ru' ? '/ru' : ''
    },
  },
}
</script>

<style scoped></style>
